import React, { ComponentType, SyntheticEvent } from 'react';

import { Helmet } from 'react-helmet';
import { useLocation } from 'react-router-dom';

import { Box, Container, Tab, Tabs } from '@mui/material';

import useAppNavigation from '~/hooks/useAppNavigation';

import PageHeader from '../Common/Elements/PageHeader';

import Preferences from './Preferences';
import TripPlannerActivityLocation from './TripPlannerActivityLocation';
import TripPlannerContent from './TripPlannerContent';
import TripPlannerGenerateTripsFromCart from './TripPlannerGenerateTripsFromCart';
import TripPlannerImagesForSuggestedPlaces from './TripPlannerImagesForSuggestedPlaces';

type TripPlannerClassicTab = {
  path: string;
  title: string;
  component: ComponentType;
};

export const classicTripPlannerTabs: ReadonlyArray<TripPlannerClassicTab> = [
  {
    path: '/trip-planner/classic/trips',
    title: 'Trip Planner',
    component: TripPlannerContent,
  },
  {
    path: '/trip-planner/classic/preferences',
    title: 'Preferences',
    component: Preferences,
  },
  {
    path: '/trip-planner/classic/location',
    title: 'Location',
    component: TripPlannerActivityLocation,
  },
  {
    path: '/trip-planner/classic/generate-trips-from-cart',
    title: 'Generate Trips from Cart',
    component: TripPlannerGenerateTripsFromCart,
  },
  {
    path: '/trip-planner/classic/images-for-suggested-places',
    title: 'Images for suggested places',
    component: TripPlannerImagesForSuggestedPlaces,
  },
];

function TripPlannerClassicPage() {
  const { push } = useAppNavigation();
  const { pathname } = useLocation();

  const currentTab = classicTripPlannerTabs.find((tab) => tab.path === pathname) ?? classicTripPlannerTabs[0];

  const handleTabChange = (_event: SyntheticEvent, newValue: string) => {
    push(newValue);
  };

  const CurrentTabComponent = currentTab.component;

  return (
    <Container maxWidth="lg">
      <Helmet>
        <title>TripPlanner - Classic - {currentTab.title}</title>
      </Helmet>
      <PageHeader title={`TripPlanner - Classic - ${currentTab.title}`} />

      <Box sx={{ borderBottom: 1, borderColor: 'divider', mb: 3 }}>
        <Tabs value={currentTab.path} onChange={handleTabChange}>
          {classicTripPlannerTabs.map((tab) => (
            <Tab key={tab.path} value={tab.path} label={tab.title} />
          ))}
        </Tabs>
      </Box>

      <CurrentTabComponent />
    </Container>
  );
}

export default TripPlannerClassicPage;
